/* eslint-disable no-unused-vars */
/* eslint-disable import/no-webpack-loader-syntax */
/* eslint-disable import/no-unresolved */
import {
    Dispatch,
    ReactNode,
    useEffect,
    useRef,
} from 'react';
import Map, { MapRef, Marker } from 'react-map-gl';
import { ICoordinates } from '../../interfaces/map.interface';

interface MapBoxProps {
    apiKey: string;
    center: ICoordinates;
    zoom?: number;
    bounds?: [number, number, number, number] | null;
    children?: ReactNode;
    setMapsLoaded?: Dispatch<any>;
    onCenterChanged?: (center: ICoordinates) => void;
}

const MapBox = ({
    apiKey,
    center,
    zoom = 12,
    bounds,
    children = [],
    setMapsLoaded,
    onCenterChanged,
}: MapBoxProps) => {
    const mapRef = useRef<MapRef>(null);

    let removeUndefined: any = [];
    if (!Array.isArray(children)) {
        removeUndefined = [children];
    } else {
        removeUndefined = children;
    }

    removeUndefined = removeUndefined.filter((child: any) => child);

    const markers = removeUndefined.map((child: any, index: number) => (
        <Marker
            key={child.key || index}
            latitude={child.props.lat}
            longitude={child.props.lng}
        >
            {child}
        </Marker>
    ));

    useEffect(() => {
        mapRef.current?.flyTo({
            center: [center.lng, center.lat],
            zoom,
            duration: 1000,
        });
    }, [center.lng, center.lat, zoom]);

    useEffect(() => {
        if (!bounds) return;
        mapRef.current?.fitBounds(
            [[bounds[0], bounds[1]], [bounds[2], bounds[3]]],
            { padding: 80, duration: 1000, maxZoom: 13 },
        );
    }, [bounds?.join()]);

    return (
        <Map
            ref={mapRef}
            // @ts-ignore
            mapLib={import('!mapbox-gl')}
            mapboxAccessToken={apiKey}
            initialViewState={{
                longitude: center.lng,
                latitude: center.lat,
                zoom,
            }}
            style={{ width: '100%', height: '100%' }}
            mapStyle="mapbox://styles/mapbox/light-v11"
            onLoad={(e: any) => {
                const map: any = e.target;
                if (setMapsLoaded) {
                    setMapsLoaded(map);
                }
                if (onCenterChanged) {
                    // @ts-ignore
                    map.on('dragend', () => {
                        // @ts-ignore
                        onCenterChanged({
                            lng: map.getCenter().lng,
                            lat: map.getCenter().lat,
                        });
                    });
                }
            }}
        >
            {markers}
        </Map>
    );
};

export { MapBox };
